module.exports = __webpack_public_path__ + "static/img/ar.ed7689cc.png";